<template>
  <div>
    <CreateRoleButton/>
    <RoleSearch/>
    <RoleTable/>
  </div>
</template>

<script>
import  CreateRoleButton  from '@/components/backend/role/CreateRoleButton.vue'
import  RoleSearch  from '@/components/backend/role/RoleSearch.vue'
import  RoleTable from '@/components/backend/role/RoleResults.vue'

export default {
  name: 'Roles',
  components: {
    CreateRoleButton,
    RoleSearch,
    RoleTable
  }
}
</script>

<style scoped>

</style>
